<div class="bug-report-container">
  <h2>{{ "account-admin.title.bugreports" | translate }}</h2>

  <form [formGroup]="bugReportForm" (ngSubmit)="onSubmit()">
    <div class="form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" placeholder="Enter a descriptive title" required />
        @if (bugReportForm.get("title")?.hasError("required")) {
          <mat-error>Title is required</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Steps to Reproduce</mat-label>
        <textarea matInput formControlName="description" rows="10" placeholder="Describe the bug in detail" required></textarea>
        @if (bugReportForm.get("description")?.hasError("required")) {
          <mat-error>Steps are required</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Bug Severity</mat-label>
        <mat-select formControlName="severity" required>
          @for (severityOption of severityOptions; track severityOption.value) {
            <mat-option [value]="severityOption.value">{{ severityOption.icon }} {{ severityOption.label }}</mat-option>
          }
        </mat-select>
        @if (bugReportForm.get("severity")?.hasError("required")) {
          <mat-error>Severity is required</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="checkbox-group">
      <mat-checkbox formControlName="prodBug">Production Bug</mat-checkbox>
      <mat-checkbox formControlName="reportedByCsm">Reported by CSM</mat-checkbox>
      <mat-checkbox formControlName="affectedCustomer">Affected Customer</mat-checkbox>
    </div>

    <div class="form-field file-upload">
      <div class="upload-area" (drop)="onDrop($event)" (dragover)="onDragOver($event)" (paste)="onPaste($event)" tabindex="0">
        <p>Click and then paste screenshots or videos here, you can upload multiple if you want.</p>
        <input type="file" accept="image/*,video/*" required multiple (change)="onFilesSelected($event)" #fileInput hidden />
        <button type="button" mat-stroked-button (click)="fileInput.click()">Browse Files</button>
      </div>
      @if (bugReportForm.get("screenshots")?.hasError("required")) {
        <mat-error class="imageReq">Image is required</mat-error>
      }

      @if (selectedFiles.length > 0) {
        <div class="selected-files">
          @for (file of selectedFiles; track file; let i = $index) {
            <div class="selected-file">
              <span>{{ file.name }}</span>
              @if (file.previewUrl) {
                <img [src]="file.previewUrl" alt="Preview" />
              }
              <button type="button" mat-icon-button (click)="removeFile(i)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
        </div>
      }
    </div>

    <div class="action-buttons">
      <button type="button" mat-stroked-button class="secondary-button" (click)="closeDialog()">Cancel</button>
      <button type="submit" mat-stroked-button class="primary-button" [disabled]="bugReportForm.invalid || isSubmitting">
        @if (!isSubmitting) {
          <span>Submit</span>
        }
        @if (isSubmitting) {
          <mat-spinner diameter="20"></mat-spinner>
        }
      </button>
    </div>
  </form>
</div>
